import CustomDialog from './Dialog';
import { Box } from '@mui/material';
import CustomTextfield from './Textfield';
import type { Validator } from 'api/types';
import CustomButton from './Button';
import { useEffect, useState } from 'react';

const EditDescriptionModal = ({
  onClose,
  open,
  onClickSubmit,
  initialValue = '',
  title = 'Edited',
  validator,
  maxLength,
  name,
  readOnly = false
}: {
  onClose: () => void;
  open: boolean;
  onClickSubmit?: (value: string) => void;
  initialValue?: string;
  name: string;
  title?: string;
  validator?: Validator;
  maxLength?: number;
  readOnly?: boolean;
}) => {
  const [value, setValue] = useState(initialValue);
  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  return (
    <CustomDialog
      open={open}
      closeDialog={onClose}
      maxWidth="md"
      title={title}
      content={
        <Box>
          <CustomTextfield
            name={name}
            onChange={(e) => {
              if (!readOnly) {
                setValue(e.target.value);
              }
            }}
            value={value}
            placeholder="Edit Description..."
            validator={validator}
            maxLength={maxLength}
            isRequired
            isTextarea
          />
        </Box>
      }
      actions={
        <>
          {readOnly === false && (
            <CustomButton label="Submit" onClick={() => onClickSubmit?.(value)} />
          )}
          <CustomButton label="Close" onClick={onClose} />
        </>
      }
    />
  );
};

export default EditDescriptionModal;
